module.exports = __webpack_public_path__ + "static/media/business.53cda0bb.jpg";